import type { DocPage } from "../types";

export const page: DocPage = {
  slug: "markets",
  title: "Markets and company research",
  navLabel: "Markets and research",
  description:
    "Use Markets for company reports, earnings, news, technicals, macro context, and stock screening in one research flow.",
  section: "agent-research",
  published: "2026-08-03",
  updated: "2026-08-03",
  targets: ["Mavori Markets", "Mavori company research", "Mavori stock screener"],
  related: ["agent", "data", "strategies"],
  blocks: [
    {
      type: "lead",
      text: "Markets is the structured research surface beside the agent. Use it to discover securities, inspect a company from several angles, follow market events, and turn a broad universe into a shortlist you can investigate further.",
    },

    { type: "h2", text: "Find a security or market view" },
    {
      type: "p",
      text: "Search by company name or ticker to open a report. Markets also brings together news and events, the stock screener, and macro views. On mobile, Search is the entry point to the same research family.",
    },

    { type: "h2", text: "Read a company report" },
    {
      type: "p",
      text: "A company report organizes the available evidence into focused views such as company profile, financial performance, valuation, earnings, ownership, price action, options, catalysts, and market context. Use the views that answer the question in front of you instead of treating every tab as a checklist.",
    },
    {
      type: "p",
      text: "Continue in chat when you want a comparison, an explanation of a filing or earnings change, or a synthesis across several views. State the date range and comparison set so the answer stays bounded.",
    },

    { type: "h2", text: "Follow events and the market backdrop" },
    {
      type: "p",
      text: "News and event views group market-moving developments with their sources. Earnings views put reported results beside expectations and prior periods. Macro views provide rates, inflation, labor, growth, and risk context. These surfaces provide evidence for a decision; they do not replace company-specific analysis.",
    },

    { type: "h2", text: "Screen before researching deeply" },
    {
      type: "p",
      text: "Use the screener to filter and sort the supported equity universe by the fields that express your idea. Start with a small number of meaningful conditions, review the coverage shown with the result, and then open individual matches for company-level research. A screen is a discovery step, not a ranked recommendation.",
    },

    { type: "h2", text: "Read source and coverage context" },
    {
      type: "p",
      text: "Market views show source and as-of information where freshness changes the interpretation. Some datasets refresh during a session, while filings, fundamentals, ownership, and macro series follow their own publication schedules. [Data coverage and freshness](/docs/data) lists the supported markets, delays, and history boundaries.",
    },
  ],
};
